'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  'btn:save': 'Save',
  'btn:cancel': 'Cancel',
  'btn:clear': 'Clear'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/lib/color-picker/locale/en_US.js
// module id = vP5m
// module chunks = 0